import type { StepResult } from "../api/client";
import { Callout } from "../components/Callout";

/**
 * The server's advisory findings for a step.
 *
 * Advisories are recorded consequences, not refusals: a suspended accreditation, an
 * absent impartiality committee, declared consultancy. They do not stop the application
 * being written down — they are what the Complao administrator reads when deciding
 * whether the certification body can be activated. Each carries the clause it comes from,
 * because a warning without its source is an opinion.
 */
export function Advisories({ result }: { result: StepResult | null }) {
  if (!result || result.advisory.length === 0) return null;

  return (
    <>
      {result.advisory.map((issue) => (
        <Callout key={`${issue.field}:${issue.detail}`} tone="warn">
          {issue.detail}
          {issue.reference ? <span className="src">{issue.reference}</span> : null}
        </Callout>
      ))}
    </>
  );
}
